import { render } from "./AskForPaymentElement.vue?vue&type=template&id=1cff7c89&scoped=true"
import script from "./AskForPaymentElement.vue?vue&type=script&lang=js"
export * from "./AskForPaymentElement.vue?vue&type=script&lang=js"

import "./AskForPaymentElement.vue?vue&type=style&index=0&id=1cff7c89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cff7c89"]])

export default __exports__